export const states = [
    'AL',
    'AK',
    'AR',
    'AZ',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'IA',
    'ID',
    'IL',
    'IN',
    'KS',
    'KY',
    'LA',
    'MA',
    'MD',
    'ME',
    'MI',
    'MN',
    'MO',
    'MS',
    'MT',
    'NC',
    'ND',
    'NE',
    'NH',
    'NJ',
    'NM',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VA',
    'VT',
    'WA',
    'WI',
    'WV',
    'WY',
]

export const ClientStatuses = [
    {
        value: 'allClients',
        label: 'All Clients',
        key: 'all',
    },

    {
        value: 'open',
        label: 'Open',
        key: 'Open',
    },
    {
        value: 'presented',
        label: 'Presented',
        key: 'Presented',
    },
    {
        value: 'applicationSubmitted',
        label: 'Submitted',
        key: 'ApplicationSubmitted',
    },
    {
        value: 'applicationApproved',
        label: 'Approved',
        key: 'ApplicationApproved',
    },
    {
        value: 'approvalCasePlaced',
        label: 'Placed',
        key: 'ApprovalCasePlaced',
    },
    {
        value: 'applicationDeclined',
        label: 'Declined',
        key: 'ApplicationDeclined',
    },
    {
        value: 'approvalNotTaken',
        label: 'Not Taken',
        key: 'ApprovalNotTaken',
    },
    {
        value: 'abandoned',
        label: 'Abandoned',
        key: 'Abandoned',
    },
]
